/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ priority: NonNullable<unknown> }} Task_Priority_LabelInputs */

const en_task_priority_label = /** @type {(inputs: Task_Priority_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.priority === "low") return /** @type {LocalizedString} */ (`Low`);
	if (i?.priority === "medium") return /** @type {LocalizedString} */ (`Medium`);
	if (i?.priority === "high") return /** @type {LocalizedString} */ (`High`);
	if (i?.priority === "critical") return /** @type {LocalizedString} */ (`Critical`);
	return /** @type {LocalizedString} */ (`${i?.priority}`)
	
};

const pt_br2_task_priority_label = /** @type {(inputs: Task_Priority_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.priority === "low") return /** @type {LocalizedString} */ (`Baixa`);
	if (i?.priority === "medium") return /** @type {LocalizedString} */ (`Média`);
	if (i?.priority === "high") return /** @type {LocalizedString} */ (`Alta`);
	if (i?.priority === "critical") return /** @type {LocalizedString} */ (`Crítica`);
	return /** @type {LocalizedString} */ (`${i?.priority}`)
	
};

/**
* | priority | output |
* | --- | --- |
* | "low" | "Low" |
* | "medium" | "Medium" |
* | "high" | "High" |
* | "critical" | "Critical" |
* | * | "{priority}" |
*
* @param {Task_Priority_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_priority_label = /** @type {((inputs: Task_Priority_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Priority_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_priority_label(inputs)
	return pt_br2_task_priority_label(inputs)
});